import api, {
  PaginateRequest, PaginateResponse, ResponseCallback
} from '../services/api.service'
import alertService from '../services/alert.service'
import routeUtil from '../utils/route.util'
import { ShipOrderData } from './shipOrder.api'
import { SiteData } from './site.api'
import { UserData } from './user.api'

export interface BillOfLadingData {
  id: number
  siteId: number
  shipOrderId: number
  createdBy: number
  updatedBy: number
  trailerNumber?: string
  sealNumber?: string
  supervisorName?: string
  driverName?: string
  supervisorSignature?: string
  driverSignature?: string
  carrier?: string
  note?: string
  driverCheckInAt?: string
  loadStartAt?: string
  departureAt?: string
  createdAt: string
  updatedAt: string
  code: string
  shipOrder?: ShipOrderData
  site?: SiteData
  createdUser?: UserData
}

type BillOfLadingPaginateResponse = PaginateResponse<BillOfLadingData[]>

export interface BillOfLadingUpdateRequest {
  loadStartTime?: string
  departureTime?: string
  trailerNumber?: string
  sealNumber?: string
  carrier?: string
  note?: string
  driverCheckIn?: string
  supervisorName?: string
  driverName?: string
  supervisorSignature?: string
  driverSignature?: string
}

const routes = {
  paginate: '/billsOfLading/paginate',
  export: '/billsOfLading/export',
  read: '/billsOfLading/{id}',
  update: '/billsOfLading/{id}',
  generate: '/billsOfLading/{id}/generate'
}

export default {
  paginate (
    params: PaginateRequest,
    callback: ResponseCallback<BillOfLadingPaginateResponse>
  ) {
    api.get(routes.paginate, params, callback)
  },

  export (callback: ResponseCallback<Blob>) {
    api.get(routes.export, {}, callback)
  },

  read (id: number, callback: ResponseCallback<BillOfLadingData>) {
    const url = routeUtil.replaceParams(routes.read, { id })
    api.get(url, {}, callback)
  },

  update (
    id: number,
    payload: BillOfLadingUpdateRequest,
    callback: ResponseCallback<BillOfLadingData>
  ) {
    const url = routeUtil.replaceParams(routes.update, { id })
    api.patch(url, payload, callback)
  },

  generate (id: number, callback: ResponseCallback<string>) {
    alertService.info('Bill of lading generating...')
    const url = routeUtil.replaceParams(routes.generate, { id })
    api.get(url, {}, callback)
  }
}
